module.exports = __webpack_public_path__ + "img/logo_web.4a1a78eb.png";